import { CheckCircle, DisabledByDefault } from "@mui/icons-material";
import {
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

const DetailProgressTable = ({ detail }) => {
  if (!detail) return <></>;
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableBody>
          {detail.map((status, index) => {
            return (
              <TableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": {
                    border: 0,
                  },
                }}
              >
                <TableCell>{status.name}</TableCell>
                <TableCell align="center">
                  {status.is_done ? (
                    <CheckCircle className="text-green-500" />
                  ) : (
                    <DisabledByDefault className="text-red-500" />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailProgressTable;
